import { NylasSendMessageRequestContent, NylasSendMessageResponseContent } from "@equaliq/api-model-v2";
import { createApiRequest } from "../common";

/**
 * API function to send an email message via Nylas
 * @param request Email composition parameters (connectionId, to, subject, body, etc.)
 * @returns Promise with sent message details
 */
export const sendIntegrationMessageApi = async (request: NylasSendMessageRequestContent): Promise<NylasSendMessageResponseContent> => {
  const apiRequest = createApiRequest<NylasSendMessageResponseContent>('post', '/integrations/nylas/messages/send');
  return apiRequest(request);
};
